import './AvailabilitySlot.css';

/**
 * AvailabilitySlot - affiche un créneau horaire.
 *
 * Props :
 *   time      — "10:00"
 *   available — booléen (false couvre AUSSI les créneaux bloqués staff)
 *   remaining — nombre de places restantes
 *   onClick   — callback sélection
 *   disabled  — créneau passé / inactif
 *   selected  — créneau actuellement sélectionné
 *
 * Aucune prop "blocked" ou "isBlocked" n'est acceptée.
 * Un créneau bloqué est traité comme "Complet" côté API.
 */
export default function AvailabilitySlot({ time, available, remaining, onClick, disabled, selected }) {
  const isFull = !available || remaining === 0;

  if (disabled) {
    return (
      <div className="slot slot-disabled" aria-disabled="true">
        <span className="slot-time">{time}</span>
        <span className="slot-badge">Indisponible</span>
      </div>
    );
  }

  if (isFull) {
    return (
      <div className="slot slot-full" aria-disabled="true">
        <span className="slot-time">{time}</span>
        <span className="slot-badge">Complet</span>
      </div>
    );
  }

  return (
    <button
      type="button"
      className={`slot slot-available${selected ? ' slot-selected' : ''}`}
      onClick={() => onClick?.(time)}
    >
      <span className="slot-time">{time}</span>
      <span className="slot-info">
        <span className="slot-remaining">
          {remaining == null ? 'Disponible' : `${remaining} place${remaining > 1 ? 's' : ''}`}
        </span>
      </span>
    </button>
  );
}
